import './styles/index.scss';
import {isMobileDevice, isAndroid} from './js/utils';

document.body.className = isMobileDevice() ? 'mobile' : 'desktop';

if (isAndroid()) {
    document.querySelector('.store-banner__desc').textContent = "Free on Google Play";
}
